/**
 * @fileoverview Componente atomizado para mostrar el mensaje de MIA activa en el inbox.
 * @module MiaActiveMessageMC
 * @category Component - Atom
 * @since 1.0.0
 */
import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';

/**
 * MiaActiveMessageMC - Componente para mostrar el mensaje cuando MIA está gestionando la conversación.
 */
const MiaActiveMessageMC = memo(() => {
  const { t } = useTranslation('InboxMC');
  return (
    <div className="tw-wrapper tw-flex tw-w-full">
      <div className="tw-w-full tw-flex tw-flex-col tw-items-center tw-justify-center tw-py-4">
        <div className="tw-px-5 tw-text-sm tw-text-gray-950 tw-break-words tw-text-center tw-mb-4">
          {t('mia_active_message')}
        </div>
      </div>
    </div>
  );
});

MiaActiveMessageMC.displayName = 'MiaActiveMessageMC';

export default MiaActiveMessageMC;
